import { Typography } from '@material-ui/core'
import React from 'react'

const ToolTipItemPet = (props) => {
    let { message, color } = props
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
                style={{
                    height: '9px',
                    width: '9px',
                    backgroundColor: `${color ? color : '#EB4C4C'}`,
                    borderRadius: '50%',
                    display: 'inline-block',
                    marginRight: '16px'
                }}
            />
            <Typography style={{ fontWeight: 600, fontSize: '14px' }}>{message}</Typography>
        </div>
    )
}

export default ToolTipItemPet;